module.exports = __webpack_public_path__ + "img/tick.b0a20c39.png";